import { render, staticRenderFns } from "./BaseInputV2.vue?vue&type=template&id=16bfd2c8&scoped=true&"
import script from "./BaseInputV2.vue?vue&type=script&lang=js&"
export * from "./BaseInputV2.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputV2.vue?vue&type=style&index=0&id=16bfd2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bfd2c8",
  null
  
)

export default component.exports